export const SET_ORDERS = "SET_ORDERS";
export const SET_ITEM = "SET_ITEM";
export const SET_ITEMS = "SET_ITEMS";
export const UPDATE_ITEMS = "UPDATE_ITEMS";
export const SET_DISCOUNT = "SET_DISCOUNT";
export const SET_SERVICEFEE = "SET_SERVICEFEE";
export const SET_TABLE = "SET_TABLE";
